export enum PimProductsOverviewPageLayoutEnum {
    LIST = 'LIST',
    TILES = 'TILES',
}
